import type { SubjectDto, TeacherSubjectDto } from '../api/axios';
import type { SchoolCode } from '../types';

export function resolveTeacherSubjectLabel(
  ts: TeacherSubjectDto,
  allSubjects: SubjectDto[] = []
): string | null {
  const embedded = ts.subject?.name?.trim();
  if (embedded) {
    return embedded;
  }

  return allSubjects.find((s) => s.id === ts.subject_id)?.name?.trim() ?? null;
}

export function teacherSubjectsForForm(
  teacherSubjects: TeacherSubjectDto[],
  form: number,
  allSubjects: SubjectDto[],
  schoolFallback: SchoolCode
): SubjectDto[] {
  const seen = new Set<number>();
  const subjects: SubjectDto[] = [];

  for (const ts of teacherSubjects) {
    if (Number(ts.form) !== Number(form)) {
      continue;
    }
    if (seen.has(ts.subject_id)) {
      continue;
    }
    seen.add(ts.subject_id);

    const fromCatalog = allSubjects.find((s) => s.id === ts.subject_id);
    if (fromCatalog) {
      subjects.push(fromCatalog);
      continue;
    }

    const name = resolveTeacherSubjectLabel(ts, allSubjects);
    if (name) {
      subjects.push({
        id: ts.subject_id,
        name,
        code: '',
        school: schoolFallback,
      });
    }
  }

  return subjects.sort((a, b) => a.name.localeCompare(b.name));
}

export function teacherMatchesSubjectForm(
  ts: TeacherSubjectDto,
  form: number,
  subjectValue: string,
  allSubjects: SubjectDto[] = []
): boolean {
  if (Number(ts.form) !== Number(form)) {
    return false;
  }

  const label = resolveTeacherSubjectLabel(ts, allSubjects);
  if (!label) {
    return false;
  }

  return label.toUpperCase() === subjectValue.trim().toUpperCase();
}
